import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import DashboardAgents from '../DashboardAgents';
import DashboardGroups from '../DashboardGroups';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: object; // Added sx prop for styling
}
interface MyComponentProps {
  refreshTab: boolean
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, ...sx }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const DashboardTab: React.FC<MyComponentProps> = (props) => {
  const [tabId, setTabId] = React.useState(0);


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabId(newValue);
  };


  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabId} onChange={handleChange} aria-label="dashboard tabs">
          <Tab icon={<AutoFixHighOutlinedIcon />} iconPosition="start" label="MY AGENTS" {...a11yProps(0)} />
          {/* <Tab icon={<AccountTreeOutlinedIcon />} iconPosition="start" label="MY GROUPS" {...a11yProps(1)} /> */}
          {/* <Tab icon={<FavoriteBorderOutlinedIcon />} iconPosition="start" label="MY FAVORITES" {...a11yProps(1)} /> */}
        </Tabs>
      </Box>
      {/* Agents */}
      <CustomTabPanel value={tabId} index={0} sx={{ px: 0 }}>
        <DashboardAgents tabId={tabId} refreshTab={props.refreshTab} />
      </CustomTabPanel>
      {/* Groups */}
      {/* <CustomTabPanel value={tabId} index={1} sx={{ px: 0 }}>
        <DashboardGroups />
      </CustomTabPanel> */}
      {/* My favorites */}
      {/* <CustomTabPanel value={tabId} index={1} sx={{ px: 0 }}> */}
      {/* <DashboardAgents tabId={tabId}/> */}
      {/* </CustomTabPanel> */}
    </Box>
  );
};

export default DashboardTab;
